import { create } from 'zustand';

/**
 * UI-facing sync status.
 * status: 'local' (no account / cloud not configured) | 'idle' | 'syncing' | 'offline' | 'error'
 */
export const useSyncStore = create(() => ({
  status: 'local',
  lastSyncAt: null,
  lastError: null,
  retryAt: null,
  integrity: null, // null | 'ok' | 'repaired' | 'mismatch'
  lastIntegrityAt: null,
  lastCloudBackupAt: null,
}));

export function setSyncState(patch) {
  useSyncStore.setState(patch);
}
